import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getTabProps = function getTabProps(_ref) {
  var activeKey = _ref.activeKey,
    additionalTabProps = _ref.additionalTabProps;
  /**
   * This is done because of a code piece in rc-tabs
   * if (activeKey in props)
   */
  if (!activeKey) {
    return additionalTabProps;
  }
  var tableProps = _objectSpread(_objectSpread({}, additionalTabProps), {}, {
    activeKey: activeKey
  });
  return tableProps;
};